import { SimulationsPage } from './simulations-page';

export default SimulationsPage;
